export function stripParamFromUrl(input: string, param: string): string {
    const url = new URL(input);

    const params = url.searchParams;
    params.delete(param);
    url.search = params.toString();

    return url.toString();
}
